import { StepperData } from "@/components/molecules/Progress/FlowSteps/FlowSteps";
import { defaultDateFormat } from "@/core/date";
import { fakeI18n } from "@/i18n";

import { RegisterFormType } from "./formType";

export enum RegisterSteps {
    CHOOSE_BROKER = "choose_broker",
    COMPLETE_PROFILE = "complete_profile",
    CONFIRMATION = "confirmation",
    CREATE_PASSWORD = "create_password",
    ACCOUNT_CREATED = "account_created",
    ITSME_UNKNOWN = "itsme_unknown",
    ITSME_CHOOSE_BROKER = "itsme_choose_broker",
}

export const stepperData = [
    {
        key: RegisterSteps.CHOOSE_BROKER,
        label: fakeI18n.t("Registration.Steps.ChooseBroker"),
    },
    {
        key: RegisterSteps.COMPLETE_PROFILE,
        label: fakeI18n.t("Registration.Steps.CompleteProfile"),
    },
    {
        key: RegisterSteps.CONFIRMATION,
        label: fakeI18n.t("Registration.Steps.Confirmation"),
    },
    {
        key: RegisterSteps.CREATE_PASSWORD,
        label: fakeI18n.t("Registration.Steps.CreatePassword"),
    },
];

export const getStepperData = (fromItsme = false): StepperData[] => {
    if (fromItsme) {
        return stepperData.filter((step) => step.key !== RegisterSteps.CREATE_PASSWORD);
    }

    return stepperData;
};

export const getSignUpObject = (formValues: RegisterFormType, language: string): MyBrokerApi.RegistrationModel => {
    const { officeId, email, profile } = formValues;
    return {
        officeId,
        email,
        familyName: profile.lastName,
        firstName: profile.firstName,
        dateOfBirth: defaultDateFormat(profile.birthdate),
        mobilePhone: profile.phoneNumber?.replace?.(/[^+\d]+/g, ""),
        language,
    };
};
